import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "xlc_ic",
  "use": "xlc_ic-usage",
  "viewBox": "0 0 17 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 22\" id=\"xlc_ic\"><g fill-rule=\"nonzero\" fill=\"none\"><path fill=\"#2AB63E\" d=\"M0 0h10.973L17 6.063V22H0z\" /><path fill=\"#367C33\" d=\"M11 0l6 6h-6z\" /><g fill=\"#FFF\"><path d=\"M3.5 8.5h10v10h-10v-10zm1 1v8h8v-8h-8z\" /><path d=\"M6.5 11.5h-3v1h3v2h-3v1h3v3h1v-3h6v-1h-6v-2h6v-1h-6v-3h-1z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol